import React from 'react'
import { IndexLink, Link } from 'react-router'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
//import styles
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import { Helmet } from 'react-helmet'
import BGM from './BGM'
import qs from 'qs'
import { wxConfig, backendConfig, homepageDir } from '../../../constant/wxConfig'
import { LOGIN } from '../../store/userConstant'
import Poster from './Poster'
import './PageLayout.css'

const jsApiList = ['startRecord', 'stopRecord', 'onVoiceRecordEnd',
  'playVoice', 'pauseVoice', 'stopVoice', 'onVoicePlayEnd',
  'uploadVoice', 'translateVoice', 'onMenuShareTimeline',
  'onMenuShareAppMessage']

class PageLayout extends React.Component {

  constructor(props) {
    super(props)
    // const query = props.location.query
    // 静默登录 可以获取code
    // if (!query.state) {
    //   this.quietLogin()
    // }
    this.state = {
      showToast: false,
      toastMessage: '',
      toastIcon: '',
      showPoster:(props.location.query.code || props.location.pathname.indexOf('all_users') !== -1) ? false : true
    }
  }

  static childContextTypes = {
    initLogin: React.PropTypes.func,
    displayToast: React.PropTypes.func,
    clearToast:React.PropTypes.func,
    divToast:React.PropTypes.func,
    setShareInfos:React.PropTypes.func
  }

  getChildContext = () => ({
    initLogin: this.quietLogin,
    displayToast: this.displayToast,
    clearToast:this.clearToast,
    divToast:this.divToast,
    setShareInfos:this.setShareInfos
  })

  setShareInfos = ({ shareLink, shareTitle, shareIcon }) => {
    wx.ready((res) => {
      wx.onMenuShareTimeline({
        title: shareTitle, // 分享标题
        link: shareLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: shareIcon, // 分享图标
        success: function () {
          // 用户确认分享后执行的回调函数
        }, cancel: function () {
          // 用户取消分享后执行的回调函数
        }
      });
  
      wx.onMenuShareAppMessage({
        title: shareTitle, // 分享标题
        desc: '', // 分享描述
        link: shareLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: shareIcon, // 分享图标
        type: '', // 分享类型,music、video或link，不填默认为link
        dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
        success: function () {
          // 用户确认分享后执行的回调函数
        },
        cancel: function () {
          // 用户取消分享后执行的回调函数
        }
      });
    })
  }

  clearToast = () => {
    try {
      clearTimeout(this.toastTimeout)
      this.toastTimeout.close()
    } catch (error) {
    }
    this.setState({
      showToast: false
    })
  }

  divToast = ({ toastMessage, toastIcon }) => {
    this.setState({
      showToast:true,
      toastMessage,
      toastIcon
    })
  }

  displayToast = ({ toastMessage, toastIcon, callBack = () => { }, toastDuration = 2000 }) => {
    clearTimeout(this.toastTimeout)
    this.setState({
      showToast: true,
      toastMessage: toastMessage,
      toastIcon: toastIcon
    }, () => {
      this.toastTimeout = setTimeout(() => {
        this.setState({
          showToast: false
        }, () => {
          callBack()
        })
      }, toastDuration)
    })
  }

  componentDidMount() {
    this.configWxInterface()
    if (this.state.showPoster) {
      this.setShareInfos({
        shareIcon:backendConfig.serverHost + '/official/share_icon.jpg',
      })
    }
    const query = this.props.location.query
    // 获取code后非静默授权
    if (query.code) {
      fetch(backendConfig.serverHost + '/login/' + query.code)
        .then(res => res.json())
        .then(res => {
          if (res.user.openid) {
            console.log('res:', res)
            this.props.dispatch({
              type: LOGIN,
              payload: {
                user: res.user
              }
            })
            this.setState({
              showPoster:false
            })
            // 静默code获取信息后，使用非静默登录
          } else {
            this.login()
          }
        })
    }
  }

  // 静默登录 可以获取code
  quietLogin = () => {
    const loginConfig = {
      'appid': wxConfig.appId,
      'redirect_uri': homepageDir + this.props.location.pathname,
      'response_type': 'code',
      'scope': 'snsapi_base',
      'state': 'isQuietLogined'
    }
    window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?'
      + qs.stringify(loginConfig) + '#wechat_redirect'
  }

  // 非静默登录 也可以获取code
  login = (localId = '') => {
    const loginConfig = {
      'appid': wxConfig.appId,
      'redirect_uri': homepageDir + this.props.location.pathname,
      'response_type': 'code',
      'scope': 'snsapi_userinfo',
      'state': localId
    }
    window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?'
      + qs.stringify(loginConfig) + '#wechat_redirect'
  }

  configWxInterface = () => {
    const wx = window.wx
    fetch(backendConfig.serverHost + '/sign?url=' + encodeURIComponent(location.href.split('#')[0]))
      .then(res => res.json())
      .then((res) => {
        const configOptions = {
          // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          debug: false,
          // 必填，公众号的唯一标识
          appId: wxConfig.appId,
          // 必填，生成签名的时间戳
          timestamp: wxConfig.timestamp,
          // 必填，生成签名的随机串
          nonceStr: wxConfig.noncestr,
          // 必填，签名
          signature: res.sign,
          // 必填，需要使用的JS接口列表
          jsApiList: jsApiList
        }
        wx.config(configOptions);
      })
  }


  render() {
    const { showToast, toastIcon, toastMessage, showPoster } = this.state
    const { pathname } = this.props.location
    return (
      <MuiThemeProvider>
        <div className='text-center'>
          <Helmet>
            <title>十年了，我想对汶川说</title>
          </Helmet>
          {showToast && (
            <div className='layout-toast-container' >
              <div className='layout-toast-main'>
                <div
                  className='layout-toast-icon'
                >{toastIcon}</div>
                <div
                  className='layout-toast-text'
                >{toastMessage}</div>
              </div>
            </div>
          )}
          {showPoster
            ? <Poster hidePoster={() => {
              this.setState({
                showPoster:false
              })
            }} />
            : this.props.children}
          {((pathname !== '/') && (pathname !== '/board') && (pathname !== '/all_users')) && <BGM />}
        </div>
      </MuiThemeProvider>
    )
  }
}


PageLayout.propTypes = {
  children: PropTypes.node,
}


export default connect(null, null)(PageLayout)


// WEBPACK FOOTER //
// ./src/layouts/PageLayout/PageLayout.js